import App from "./app"
new App()
console.info("OES App Started")